<div class="profile-container">
  <div class="">
    <div class="profile-content">

      <div class="header-block" style="margin-bottom: 10px;">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>
      </div>
      <div class="header-block">
        <div class="header-title">
          <p><span>{{taskType | titlecase}}</span> {{ 'task.title' | translate }}</p>
        </div>
        <div class="add-block">
          <div class="filter-icon">
            <i class="bi bi-file-earmark-excel" title="Download Excel" (click)="dowuLoad()"></i>
          </div>

          <div class="search">
            <form autocomplete="off">
              <input type="text" [ngModelOptions]="{standalone: true}" (keyup.enter)="getTaskByWildSearch(0,10)"
                placeholder="search" [(ngModel)]="searchFilter">
            </form>
            <i class="bi bi-search" (click)="getTaskByWildSearch(0,10)"></i>
          </div>
          <!-- <button (click)="searchclear()">Reset</button> -->
          <button data-toggle="modal" title="Add" data-target="#exampleModal4"><i class="bi bi-plus-lg"></i>
            Add</button>

          <div class="filter-icon">
            <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i>
            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshTickets()"></i>
          </div>
          <!-- <button><i class="bi bi-plus-lg"></i> Add</button> -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 dataListStatus" *ngIf="!showFilter">
          <ul>
            <!-- <li><h4>TASK STATUS</h4></li> -->
            <li class="cp" (click)="getAllTask(0,10)">ALL<span class="green">{{taskCounts.ALL}}</span></li>
            <li class="cp" (click)="byStatus('NEW')">NEW <span class="yellow">{{taskCounts.NEW}}</span></li>
            <li class="cp" (click)="byStatus('ASSIGNED')">ASSIGNED <span class="blue">{{taskCounts.ASSIGNED}}</span>
            </li>
            <li class="cp" (click)="byStatus('REASSIGNED')">RE-ASSIGNED <span
                class="red">{{taskCounts.REASSIGNED}}</span></li>
            <li class="cp" (click)="byStatus('PENDING')">PENDING <span class="green">{{taskCounts.PENDING}}</span></li>
            <li class="cp" (click)="byStatus('COMPLETED')">COMPLETED <span
                class="yellow">{{taskCounts.COMPLETED}}</span></li>
            <li class="cp" (click)="byStatus('DEFERRED')">DEFERRED <span class="blue">{{taskCounts.DEFERRED}}</span>
            </li>
            <li class="cp" (click)="byStatus('FORCE_CLOSED')">FORCE CLOSED <span
                class="red">{{taskCounts.FORCE_CLOSED}}</span></li>
            <li class="cp" (click)="byStatus('CLOSED')">CLOSED <span class="green">{{taskCounts.CLOSED}}</span></li>
            <li class="cp" (click)="byStatus('WORK_IN_PROGRESS')">WORK IN PROGRESS <span
                class="yellow">{{taskCounts.WORK_IN_PROGRESS}}</span></li>
            <li class="cp" (click)="byStatus('PARTIALLY_COMPLETED')">PARTIALLY COMPLETED <span
                class="blue">{{taskCounts.PARTIALLY_COMPLETED}}</span></li>
          </ul>
        </div>
        <div class="col-lg-9 col-md-9 dataList" style="margin:0;padding: 0;">
          <!-- <div class="dataList-header">
                  <div class="dataList-header-left">
                    <h4>{{taskType}} TASKS</h4>
                  </div>
                  <div class="dataList-header-right">
                    <div class="filter-icon">
                      <i class="bi bi-file-earmark-medical" (click)="dowuLoad()"></i>
                    </div>
                    <input type="text" placeholder="Filter here" (keyup)="taskFilterByWildSearch(search.value)" #search [(ngModel)]="searchFilter">
                    <button (click)="searchclear()">Reset</button>
                    <div class="filter-icon">
                      <i class="bi bi-funnel" (click)="toggleFilter()"></i>
                      <i class="bi bi-arrow-clockwise" (click)="refreshTickets()"></i>

                    </div>
                  </div>
                </div> -->
          <div class="dataList-content">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 8%;">{{ 'task.ttaskId' | translate }}</th>
                  <th style="width: 22%;">{{ 'task.subject' | translate }}</th>
                  <th style="width: 35%;">{{ 'task.description' | translate }}</th>
                  <th style="width: 20%;">{{ 'task.assignedToUserName' | translate }}</th>
                  <th style="width: 15%;">{{ 'generic.action' | translate }}</th>
                </tr>
              </thead>
            </table>

            <div *ngIf="!isLoading">
              <div class="data-view" *ngFor="let task of tasks ;let i = index">

                <p style="width: 8%;">{{task.tTaskId}}</p>
                <p style="width: 22%;">{{task.name}}</p>
                <p style="width: 35%;">{{task.description}}</p>
                <p style="width: 20%;">{{task.assignedToUserName}}</p>
                <p class="action-buttons" style="width: 15%;padding-left: 25px;">
                  <i *ngIf="actionControls.isModify" class="bi bi-pencil-square" (click)="getSingleTask(task.taskId)"
                    data-toggle="modal" data-target="#editModal"></i>


                  <i *ngIf="actionControls.isView" class="bi bi-eye-fill" (click)="getSingleTask(task.taskId)"
                    data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i *ngIf="actionControls.isDelete" class="bi bi-trash3" (click)="del(task.id)" data-toggle="modal"
                    data-target="#deleteModal"></i>

                </p>

              </div>
            </div>


            <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && tasks.length == 0">
              <div class="no-data">
                <img src="assets/no-data-6.png" alt="">
                <p>no data found</p>
              </div>

            </div>

            <div class="paginator">
              <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
            </div>


            <!-- <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
                  <div class="pagination-block" *ngIf="tasks.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div> -->

            <!-- <div style="display: flex;justify-content: center;align-items: center;height: 200px;">
                    <h5 class="text-center" *ngIf="!isLoading && tasks.length == 0">No records found.</h5>
                  </div> -->
          </div>
        </div>

        <div class="col-lg-3 col-md-3">
          <div class="filter-block" *ngIf="showFilter">
            <div class="filters">
              <div class="filter-title">
                <p>Filters</p>
                <div class="filter-apply-button">
                  <button (click)="resetFilter()">Reset</button>
                  <button (click)="applyFilter()">Apply</button>
                </div>
              </div>
              <!-- <div class="single-filter form-group">
                      <label ><span><input name="filter" (click)="filterClicked('customerPhoneNoChecked')" type="radio"></span> Customer Phone No </label>
                      <input type="text" [(ngModel)]="customerPhoneNo" class="form-control">
                    </div> -->
              <div class="single-filter form-group">
                <label><span><input name="filter" [checked]="selectedFilter === 'filterDateChecked'"
                      (click)="filterClicked('filterDateChecked')" type="radio"></span> Task Filter By Dates </label>
                <input type="date" [(ngModel)]="startDate" class="form-control">
                <input type="date" [(ngModel)]="endDate" class="form-control">
              </div>
              <div class="single-filter form-group">
                <label><span><input name="filter" [checked]="selectedFilter === 'filterStatusAndDateChecked'"
                      (click)="filterClicked('filterStatusAndDateChecked')" type="radio"></span> Task Filter By Status
                  and Dates </label>
                <select name="" id="" class="form-control" [(ngModel)]="filterStatusDate">
                  <option value="ASSIGNED">ASSIGNED</option>
                  <option value="REASSIGNED">RE ASSIGNED</option>
                  <option value="PENDING">PENDING</option>
                  <option value="DEFERRED">DEFERRED</option>
                  <option value="WORK_IN_PROGRESS">WORK IN PROGRESS</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="PARTIALLY_COMPLETED">PARTIALLY COMPLETED</option>
                  <option value="CLOSED">CLOSED</option>
                  <option value="FORCE_CLOSED">FORCE CLOSED</option>
                </select>
                <input type="date" [(ngModel)]="statusStartDate" class="form-control">
                <input type="date" [(ngModel)]="statusEndDate" class="form-control">
              </div>


              <div class="single-filter form-group">
                <label><span><input name="filter"
                      [checked]="selectedFilter === 'filterByStatusAndUserIdAndDatesChecked'"
                      (click)="filterClicked('filterByStatusAndUserIdAndDatesChecked')" type="radio"></span> Filter By
                  UserId, Status and Dates </label>
                <select name="" id="" class="form-control" [(ngModel)]="statusAndUserIdAndDates">
                  <option value="ASSIGNED">ASSIGNED</option>
                  <option value="REASSIGNED">RE ASSIGNED</option>
                  <option value="PENDING">PENDING</option>
                  <option value="DEFERRED">DEFERRED</option>
                  <option value="WORK_IN_PROGRESS">WORK IN PROGRESS</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="PARTIALLY_COMPLETED">PARTIALLY COMPLETED</option>
                  <option value="CLOSED">CLOSED</option>
                  <option value="FORCE_CLOSED">FORCE CLOSED</option>
                </select>
                <select name="" id="" class="form-control" [(ngModel)]="userId">
                  <option value="{{user.userId}}" *ngFor="let user of usersWithoutCustomers">{{user.userName}}</option>
                </select>
                <input type="date" [(ngModel)]="fromDate" class="form-control">
                <input type="date" [(ngModel)]="toDate" class="form-control">
              </div>



              <div class="single-filter form-group">
                <label><span><input name="filter" [checked]="selectedFilter === 'filterByTaskIdChecked'"
                      (click)="filterClicked('filterByTaskIdChecked')" type="radio"></span> Filter By Task Id </label>
                <input type="text" [(ngModel)]="filterByTaskId" class="form-control">
              </div>

              <div class="single-filter form-group">
                <label><span><input name="filter" [checked]="selectedFilter === 'filterByTechnicianChecked'"
                      (click)="filterClicked('filterByTechnicianChecked')" type="radio"></span> Filter By Technician
                </label>
                <select name="" id="" class="form-control" [(ngModel)]="filterByTechnician">
                  <option value="{{user.userId}}" *ngFor="let user of usersWithoutCustomers">{{user.userName}}</option>
                </select>
              </div>

              <div class="single-filter form-group">
                <label><span><input name="filter" [checked]="selectedFilter === 'filterByTaskPriorityChecked'"
                      (click)="filterClicked('filterByTaskPriorityChecked')" type="radio"></span> Task Priority </label>
                <select name="" id="" class="form-control" [(ngModel)]="filterByTaskPriority">
                  <option value="HIGH">High</option>
                  <option value="MEDIUM">Medium</option>
                  <option value="LOW">Low</option>
                </select>
              </div>

              <div class="single-filter form-group">
                <label><span><input name="filter" [checked]="selectedFilter === 'filterByTaskCompletedAndDatesChecked'"
                      (click)="filterClicked('filterByTaskCompletedAndDatesChecked')" type="radio"></span> Completed
                </label>
                <select name="" id="" class="form-control" [(ngModel)]="filterByTaskCompletedAndDates">
                  <option value="0">Any Time</option>
                  <option value="1">Last One Day</option>
                  <option value="2">Last Two Days</option>
                  <option value="3">Last Three Days</option>
                  <option value="7">Last One Week</option>
                  <option value="14">Last Two Weeks</option>
                  <option value="21">Last Three Weeks</option>
                  <option value="30">Last One Month</option>
                  <option value="60">Last Two Months</option>
                  <option value="90">Last Three Months</option>
                </select>
              </div>

              <div class="single-filter form-group">
                <label><span><input name="filter" [checked]="selectedFilter === 'filterByTaskClosedAndDatesChecked'"
                      (click)="filterClicked('filterByTaskClosedAndDatesChecked')" type="radio"></span> Closed </label>
                <select name="" id="" class="form-control" [(ngModel)]="filterByTaskClosedAndDates">
                  <option value="0">Any Time</option>
                  <option value="1">Last One Day</option>
                  <option value="2">Last Two Days</option>
                  <option value="3">Last Three Days</option>
                  <option value="7">Last One Week</option>
                  <option value="14">Last Two Weeks</option>
                  <option value="21">Last Three Weeks</option>
                  <option value="30">Last One Month</option>
                  <option value="60">Last Two Months</option>
                  <option value="90">Last Three Months</option>
                </select>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }}</p>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteTask()" class="btn btn-primary">{{ 'generic.delete' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModal"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="task-content">
        <div class="c-button">
          <div class="c-right">
            <h4> <span style="margin-right: 15px;" *ngIf="ticketId != null && ticketId != ''">{{ 'task.ticketId' |
                translate }} : <span data-toggle="modal" data-target="#ticketview"
                  style="color:rgb(89, 169, 234);cursor: pointer;">{{ticketId}}</span></span> {{ 'task.title' |
              translate }} :</h4>
            <!-- <div class="priority-block">
                <p (click)="priorityToggle()" class="priority">{{tpriority}}</p>
                <div class="priority-dropdown" [ngClass]="{'priority-dropdown-toggle': priority_dropdown_toggle}">
                  <p (click)="updateTaskPriority('HIGH')">High</p>
                  <p (click)="updateTaskPriority('MEDIUM')">Medium</p>
                  <p (click)="updateTaskPriority('LOW')">Low</p>
                </div>
              </div> -->
          </div>
          <div style="align-items: center;display: flex;">
            <!-- <div class="priority-block">
                <p (click)="priorityToggle()" class="priority">{{tpriority}}</p>
                <div class="priority-dropdown" [ngClass]="{'priority-dropdown-toggle': priority_dropdown_toggle}">
                  <p (click)="updateTaskPriority('HIGH')">High</p>
                  <p (click)="updateTaskPriority('MEDIUM')">Medium</p>
                  <p (click)="updateTaskPriority('LOW')">Low</p>
                </div>
              </div> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="26" (click)="toggleNote()" height="26" fill="currentColor"
              class="bi bi-journals" viewBox="0 0 16 16">
              <path
                d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2" />
              <path
                d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0" />
            </svg>
            <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26"
              fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
              <path
                d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
              <path
                d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26"
              height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </div>
        </div>
        <div class="task-data">

          <ul class="task-header">
            <li style="width: 9%;">{{ 'task.ttaskId' | translate }}</li>
            <li style="width: 9%;">{{ 'task.taskSlNo' | translate }}o</li>
            <li>{{ 'task.completedPercentage' | translate }} %</li>
            <li>{{ 'task.createdDate' | translate }}</li>
            <li style="width: 25%;text-align: center;">{{ 'task.status' | translate }}</li>
          </ul>
          <div class="task-table" *ngFor="let task of task;let i = index">
            <ul>
              <li style="width: 9%;">#{{task.tTaskId}}</li>
              <li style="width: 9%;">{{task.taskSlNo}}</li>
              <li style="padding-left: 10px"><input class="percentageInput"
                  (focus)="TaskPercentage(completedPercentage.value)"
                  (focusout)="updateTaskPercentage(completedPercentage.value,task.id)" type="number"
                  #completedPercentage value="{{task.completedPercentage}}"> %</li>

              <li>{{task.createdDate | date}}</li>
              <li style="width: 25%;text-align: center;position: relative;background-color: white;">
                <span (click)="statusDropdown()" class="NEW">{{task.latestTaskStatus}}
                </span>
                <div class="status-dropdown-list" id="status-dropdown-list">
                  <span>ASSIGNED</span>
                  <span>REASSIGNED</span>
                  <span>WORK_IN_PROGRESS</span>
                  <span>PENDING</span>
                  <span>COMPLETED</span>
                  <span>DEFERRED</span>
                  <span>PARTIALLY_COMPLETED</span>
                  <span>FORCE_CLOSED</span>
                  <span>CLOSED</span>
                  <span>NOTE</span>
                </div>
              </li>
            </ul>
            <div class="dropdown-data" id="{{i}}">
              <div class="status-content" *ngIf="statusNote">
                <textarea name="" style="height: 70px" [(ngModel)]="note" placeholder="enter status note"
                  class="form-control" id="" cols="30" rows="10"></textarea>
                <div class="col-lg-12" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                    <input #imageInput type="file" id="add-image-btn" accept="image/*" hidden="true"
                      (change)="onChange($event)">
                  </label>
                </div>
                <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addImageBtn()">
                    <span>+ {{ 'task.addImage' | translate }}</span>
                  </div>
                  <div class="media-area"
                    style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;"
                    *ngFor="let image of images" class="mr-2">
                    <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
                  </div>
                </div>
                <select name="" id="" (change)="taskStatusDropdown()" [(ngModel)]="taskStatus">
                  <option value="WORK_IN_PROGRESS">WORK_IN_PROGRESS</option>
                  <option value="PENDING">PENDING</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="DEFERRED">DEFERRED</option>
                  <option value="PARTIALLY_COMPLETED">PARTIALLY_COMPLETED</option>
                  <option value="FORCE_CLOSED">FORCE_CLOSED</option>
                  <option value="CLOSED">CLOSED</option>
                  <option value="NOTE">NOTE</option>

                </select>
                <button (click)="updateStatus(task.taskId)" *ngIf="updatebutton == false">{{ 'task.updateStatus' |
                  translate }}</button>
              </div>
              <div class="assignedToAndTags">
                <div class="assignedTo">
                  <p>
                    <span>{{ 'task.createdBy' | translate }}</span><span>: &nbsp; {{task.createdByUserName}}</span>
                  </p>
                </div>
              </div>

              <div class="assignedToAndTags">
                <div class="assignedTo">
                  <p> <span>{{ 'task.assignTo' | translate }}</span> <span class="assignedToButton"
                      *ngIf="task.latestStatus == 'NEW'" (click)="addClass('assignedTo')">: &nbsp; {{
                      'task.clickHereToAssign' | translate }}</span> <span *ngIf="task.latestStatus != 'NEW'">: &nbsp;
                      {{task.assignedToUserName}}</span>
                    <span class="assignedToButton" *ngIf="task.latestStatus != 'NEW'" (click)="addClass('assignedTo')">
                      &nbsp; {{ 'task.clickHereToReAssign' | translate }}</span>
                  </p>
                </div>
              </div>
              <p class="task-description"><span>{{ 'task.subject' | translate }} :</span> {{task.name}}</p>
              <div class="details">
                <div *ngIf="!taskDetails_toggle">
                  <span>{{ 'task.description' | translate }}</span> <span>: &nbsp;</span> <span>{{task.description}}<i
                      (click)="upDateTaskDetailsToggle()" class="bi bi-pencil-square"></i></span>
                </div>
                <div class="updateDetails" *ngIf="taskDetails_toggle">
                  <p>{{ 'task.updateDetails' | translate }}</p>
                  <textarea name="" [(ngModel)]="updateDetails" id="" class="" cols="30" rows="3"></textarea>
                  <div class="update-details-buttons">
                    <button class="btn btn-danger" (click)="upDateTaskDetailsToggle()">{{ 'generic.cancel' | translate
                      }}</button>
                    <button class="btn btn-primary" (click)="updateTaskDescription()">{{ 'generic.update' | translate
                      }}</button>
                  </div>
                </div>
              </div>
              <!-- <p class="task-description"><span>Description :</span> {{task.description}}</p> -->

              <div class="note-content" *ngIf="showAddNote">
                <p>{{ 'task.addNote' | translate }}</p>
                <textarea name="" [(ngModel)]="tnotes" placeholder="enter note" id="" cols="30" rows="3"></textarea>
                <div class="add-note-button">
                  <button (click)="addNote()">{{ 'task.addNote' | translate }}</button>
                </div>
              </div>

              <div class="assign-and-tag-data" id="assign-and-tag-data">
                <div class="assign-to-data">
                  <div class="panel panel-default assign-panel" *ngIf="addClassType == 'assignedTo'">
                    <div class="panel-heading">
                      <h3 class="panel-title">{{ 'task.assignTo' | translate }}</h3>
                      <input type="text" class="form-control" style="width: 35%;" [(ngModel)]="assignInput"
                        placeholder="search user">
                      <select name="" id="" style="width: 35%;" [(ngModel)]="taskPriority" class="form-control">
                        <option value="HIGH">High</option>
                        <option value="MEDIUM">Medium</option>
                        <option value="LOW">Low</option>
                      </select>
                    </div>
                    <div class="panel-body">
                      <div *ngIf="task.assignedToUserName == '' || task.assignedToUserName == null">
                        <span *ngFor="let user of usersWithoutCustomers | filter: assignInput">
                          <p (click)="taskAssignToUser(task.taskId,user.userId,'ASSIGNED',user.userName)">
                            {{user.userName}} - ({{user.userType.replace("_", " ")}})</p>
                        </span>
                      </div>
                      <div *ngIf="task.assignedToUserName != ''">
                        <span *ngFor="let user of usersWithoutCustomers | filter: assignInput">
                          <p (click)="taskAssignToUser(task.taskId,user.userId,'REASSIGNED',user.userName)">
                            {{user.userName}} - ({{user.userType.replace("_", " ")}})</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default usertags-panel" *ngIf="addClassType == 'usersTaged'">
                    <div class="panel-heading">
                      <h3 class="panel-title">{{ 'task.tagUsers' | translate }}</h3>
                    </div>
                    <div class="panel-body">
                      <div>
                        <span *ngFor="let user of usersList">
                          <p>{{user.userName}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="status-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 50%;">{{ 'task.note' | translate }}</th>
                      <th style="width: 20%;text-align: center;">{{ 'task.taskStatus' | translate }}</th>
                      <th style="width: 30%;text-align: center;">{{ 'task.updatedDate' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let status of task.status">
                      <td style="width: 50%;">{{status.note}}</td>
                      <td style="width: 20%;text-align: center;">{{status.taskStatus}}</td>
                      <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="status-table" *ngIf="task.ttnotes != null && task.ttnotes.length != 0">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 50%;">{{ 'task.note' | translate }}</th>
                      <th style="width: 20%;text-align: center;">{{ 'task.userName' | translate }}</th>
                      <th style="width: 30%;text-align: center;">{{ 'task.date' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let tnotes of task.ttnotes;">
                      <td style="width: 50%;">{{tnotes.note}}</td>
                      <td style="width: 20%;text-align: center;">{{tnotes.userName}}</td>
                      <td style="width: 30%;text-align: center;">{{tnotes.date | date:'medium'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="taskTable">
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{ 'task.taskExpStartDate' | translate }}</th>
                        <th scope="col">{{ 'task.taskExpEndDate' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td *ngIf="task.taskExpStartDate != 0">{{task.taskExpStartDate | date:'medium'}}</td>
                        <td *ngIf="task.taskExpEndDate != 0">{{task.taskExpEndDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{ 'task.taskActStartDate' | translate }}</th>
                        <th scope="col">{{ 'task.taskActEndDate' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td *ngIf="task.taskActStartDate != 0">{{task.taskActStartDate | date:'medium'}}</td>
                        <td *ngIf="task.taskActEndDate != 0">{{task.taskActEndDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="image-container" *ngIf="task.image.length != 0">
                <div class="image-header">
                  <h5>{{ 'task.images-videos' | translate }}</h5>
                </div>
                <div class="image-content-block">
                  <div class="image-single" *ngFor="let image of task.image">
                    <img src="{{image}}" data-toggle="modal" data-target="#imageView" (click)="viewImage(image)" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" hidden="true">
        <button type="button" id="closeModalButton12" class="btn btn-secondary" data-dismiss="modal"
          class="btn btn-secondary">{{ 'generic.cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="ticketview" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="task-content">
        <div class="c-button">
          <div class="c-right">
            <h4>{{ 'task.ticketId' | translate }}: #{{ticketId}}
              <span data-dismiss="modal">
                <i data-dismiss="modal" class="bi bi-x-lg"></i>
              </span>
            </h4>
          </div>
        </div>
        <div class="task-data" *ngFor="let ticket of TicketData;">
          <ul class="task-header1">
            <li style="width: 20%;">{{ 'task.customerID' | translate }} </li>
            <li style="width: 20%;">{{ 'task.typeName' | translate }} </li>
            <li style="width: 20%;">{{ 'task.heading' | translate }}</li>
            <li style="width: 20%;">{{ 'task.status' | translate }}</li>
          </ul>
          <div class="task-table" style="margin-bottom: 10px;">
            <ul>
              <li style="width: 20%;">{{ticket.customerID}}</li>
              <li style="width: 20%;">{{ticket.typeName}}</li>
              <li style="width: 20%;">{{ticket.heading}}</li>
              <li style="width: 20%;text-align: center;position: relative;background-color: white;">
                <span style="padding: 5px 10px;" class="NEW">{{ticket.latestTicketStatus}}
                </span>

              </li>
            </ul>
          </div>
          <div class="details">
            <span>{{ 'task.details' | translate }}</span> <span>: &nbsp;</span> <span>{{ticket.details}}</span>
          </div>
          <div class="assignedToAndTags" *ngIf="ticket.assignedToUserName != '' && ticket.assignedToUserName != null">
            <div class="assignedTo">
              <p> <span>{{ 'task.assignTo' | translate }}</span> <span>: {{ticket.assignedToUserName}}</span>
              </p>
            </div>
          </div>

          <div class="dropdown-data">
            <div class="status-table">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 50%;">{{ 'task.note' | translate }}</th>
                    <th style="width: 20%;text-align: center;">{{ 'task.ticketStatus' | translate }}</th>
                    <th style="width: 30%;text-align: center;">{{ 'task.updatedDate' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let status of ticket.ticketStatus;">
                    <td style="width: 50%;">{{status.note}}</td>
                    <td style="width: 20%;text-align: center;">{{status.ticketStatus}}</td>
                    <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

          <div class="status-table" *ngIf="ticket.tnotes != null && ticket.tnotes.length != 0">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 50%;">{{ 'task.note' | translate }}</th>
                  <th style="width: 20%;text-align: center;">{{ 'task.userName' | translate }}</th>
                  <th style="width: 30%;text-align: center;">{{ 'task.date' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tnotes of ticket.tnotes;">
                  <td style="width: 50%;">{{tnotes.note}}</td>
                  <td style="width: 20%;text-align: center;">{{tnotes.userName}}</td>
                  <!-- <td style="width: 15%;">{{status.updatedDate | date}}</td> -->
                  <td style="width: 30%;text-align: center;">{{tnotes.date | date:'medium'}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="image-container">
            <div class="image-header">
              <h5>{{ 'task.images' | translate }}</h5>
              <!-- <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i> -->
            </div>
            <div class="image-content-block">
              <div class="image-single image-single1" style="margin-bottom: 20px;" *ngFor="let image of ticket.image">
                <!-- <img src="{{image}}" alt=""> -->
                <p-image src="{{image}}" alt="Image" width="100" height="100" [preview]="true"></p-image>

              </div>

            </div>
          </div>

          <div hidden="true">
            <input #imageInput type="file" id="add-TicketImage-btn" accept="image/*" hidden="true"
              (change)="onTicketChange($event)">
          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="imageView" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="task-content">
        <div class="c-button">
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </div>
        <div class="" style="display: flex;justify-content: center;align-items: center;height: 600px;">
          <img *ngIf="imageSingle != ''" width="300px" height="300px" src="{{imageSingle}}" alt="">
        </div>
      </div>

    </div>
  </div>
</div>







<div class="modal fade" id="exampleModal3" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'task.title' | translate }}</h5>
      </div>
      <div class="modal-body">
        <div class="status-table">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20%;">{{ 'task.seqNo' | translate }}</th>
                <th style="width: 20%;">{{ 'task.name' | translate }}</th>
                <th style="width: 40%;">{{ 'task.description' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let task of taskMasters" (click)="autoFill(task.name,task.description)">
                <td>{{task.seqNo}}</td>
                <td>{{task.name}}</td>
                <td>{{task.description}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel'
            | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>









<div class="modal fade" id="exampleModal4" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'task.headings.add' | translate }}</h5>
      </div>
      <div class="modal-body">
        <div class="addTask">
          <div [formGroup]="form">
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <div class="col-md-11 col-11" style="padding: 0">
                  <div class="form-group">
                    <label>{{ 'task.name' | translate }} <span class="required-field">*</span></label>
                    <input formControlName="name" type="text" class="form-control">
                    <!-- <span class="err" *ngIf="form.get('name').invalid">user name required</span> -->
                  </div>
                </div>
                <div class="col-md-1 col-1 task-button">
                  <div class="form-group">
                    <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#exampleModal3"
                      fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>{{ 'task.description' | translate }}</label>
                  <textarea name="" formControlName="description" id="" style="height: 70px" class="form-control"
                    cols="30" rows="10"></textarea>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>{{ 'task.assignedTo' | translate }}</label>
                  <select class="form-control" formControlName="assignedTo">
                    <option value="" disabled> -- Select User -- </option>
                    <option *ngFor="let user of usersWithoutCustomers" [value]="user.userId">{{user.userName}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group ">
                  <label>{{ 'task.tagUsers' | translate }}</label>
                  <ng-multiselect-dropdown [placeholder]="'Tag Users'" [ngModelOptions]="{standalone: true}"
                    [settings]="tagUsersdropdownSettings" [data]="tagUsersdropdownList"
                    [(ngModel)]="tagUsersselectedItems" class="form-control" style="padding: 0;border: none"
                    (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>{{ 'task.taskExpStartDate' | translate }}</label>
                  <input formControlName="taskExpStartDate" type="date" class="form-control">
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>{{ 'task.taskExpEndDate' | translate }}</label>
                  <input formControlName="taskExpEndDate" type="date" class="form-control">
                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="form-group" *ngFor="let list of keyValueList">
                  <label>{{list.key}}</label>
                  <input type="text" class="form-control" *ngIf="list.possibleValue.length == 0"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                  <select class="form-control" *ngIf="list.possibleValue.length != 0"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                    <option *ngFor="let possibleValue of list.possibleValue" [value]="possibleValue">{{possibleValue}}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-lg-12" hidden="true">
              <label class="image-upload-container btn btn-bwm">
                <!-- <span>Select Image</span> -->
                <input #imageInput type="file" id="add-image-btn" accept="image/*" hidden="true"
                  (change)="onChange($event)">
              </label>
            </div>

            <div class=" media-content">
              <div class="mr-2 image-btn" (click)="addImageBtn()">
                <span>+ {{ 'task.addImage' | translate }}</span>
              </div>
              <div class="media-area"
                style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;"
                *ngFor="let image of images" class="mr-2">
                <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
              </div>
            </div>

            <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <input #imageInput
                            type="file" id="add-video-btn"
                            accept="video/*" hidden="true"
                            (change)="onSelectFile($event)">
                    </label>
                </div>
                <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addVideoBtn()">
                    <span>+ Add video</span>
                  </div>
                  <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                      <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                  </div>
                </div> -->

            <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <input #imageInput
                            type="file" id="add-audio-btn"
                            accept="audio/*" hidden="true"
                            (change)="onSelectFile($event)">
                    </label>
                </div>
                <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addAudioBtn()">
                    <span>+ Add Audio</span>
                  </div>
                  <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                      <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                  </div>
                </div>
              
                <div *ngFor="let audio of audios" class="mr-2">
                  <audio controls>
                    <source src="{{audio}}" type="audio/mpeg">
                  </audio>
                </div> -->
          </div>
          <div class="modal-footer">
            <button type="button" id="closeModalButton6" class="btn btn-secondary" data-dismiss="modal">{{
              'generic.cancel' | translate }}</button>

            <button type="button" (click)="addTask()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'task.headings.edit' | translate }}
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="editForm">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="col-md-11 col-11" style="padding: 0">
                <div class="form-group">
                  <label>{{ 'task.name' | translate }}</label>
                  <input formControlName="name" type="text" class="form-control">
                </div>
              </div>
              <div class="col-md-1 col-1 task-button">
                <div class="form-group">
                  <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#example33"
                    fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path
                      d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>{{ 'task.description' | translate }}</label>
                <textarea name="" formControlName="description" id="" style="height: 70px" class="form-control"
                  cols="30" rows="10"></textarea>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'task.assignTo' | translate }}</label>
                <select class="form-control" formControlName="assignedTo">
                  <option value="" disabled> -- Select User -- </option>
                  <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group ">
                <label>{{ 'task.tagUsers' | translate }}</label>
                <ng-multiselect-dropdown [placeholder]="'Tag Users'" [ngModelOptions]="{standalone: true}"
                  [settings]="tagUsersdropdownSettings" [data]="tagUsersdropdownList"
                  [(ngModel)]="tagUsersselectedItems" class="form-control" style="padding: 0;border: none"
                  (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'task.taskExpStartDate' | translate }}</label>
                <input formControlName="taskExpStartDate" value="{{tasks.taskExpStartDate}}" type="date"
                  class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'task.taskExpEndDate' | translate }}</label>
                <input formControlName="taskExpEndDate" value="{{tasks.taskExpEndDate}}" type="date"
                  class="form-control">
              </div>
            </div>
          </div>

          <div class="col-lg-12" hidden="true">
            <label class="image-upload-container btn btn-bwm">
              <input #imageInput type="file" id="add-image-btn" accept="image/*" hidden="true"
                (change)="onChange($event)">
            </label>
          </div>

          <div class=" media-content">
            <div class="mr-2 image-btn" (click)="addImageBtn()">
              <span>+ {{ 'task.addImage' | translate }}</span>
            </div>
            <div class="media-area"
              style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;"
              *ngFor="let image of images" class="mr-2">
              <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
            </div>
          </div>

          <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
                <label class="image-upload-container btn btn-bwm">
                    <input #imageInput
                          type="file" id="add-video-btn"
                          accept="video/*" hidden="true"/
                          (change)="onSelectFile($event)">
                  </label>
              </div>
              <div class=" media-content">
                <div class="mr-2 image-btn" (click)="addVideoBtn()">
                  <span>+ Add video</span>
                </div>
                <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                    <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                </div>
              </div> -->

          <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
                <label class="image-upload-container btn btn-bwm">
                    <input #imageInput
                          type="file" id="add-audio-btn"
                          accept="audio/*" hidden="true"
                          (change)="onSelectFile($event)">
                  </label>
              </div>
              <div class=" media-content">
                <div class="mr-2 image-btn" (click)="addAudioBtn()">
                  <span>+ Add Audio</span>
                </div>
                <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                    <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                </div>
              </div>
            
              <div *ngFor="let audio of audios" class="mr-2">
                <audio controls>
                  <source src="{{audio}}" type="audio/mpeg">
                </audio>
              </div> -->
        </div>


        <div class="modal-footer">
          <button type="button" id="closeModalButton44" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
          <button type="button" (click)="updatetask()" class="btn btn-primary">{{ 'generic.update' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="example33" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'task.title' | translate }}</h5>
      </div>
      <div class="modal-body">
        <div class="status-table">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20%;">{{ 'task.seqNo' | translate }}</th>
                <th style="width: 20%;">{{ 'task.name' | translate }}</th>
                <th style="width: 40%;">{{ 'task.description' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let task of taskMasters" (click)="autoFill(task.name,task.description)">
                <td>{{task.seqNo}}</td>
                <td>{{task.name}}</td>
                <td>{{task.description}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton33" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>